"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var redux_saga_1 = __importDefault(require("redux-saga"));
var loggerMiddleware_1 = __importDefault(require("./middleware/loggerMiddleware"));
var rootReducer_1 = __importDefault(require("./rootReducer"));
var rootSaga_1 = __importDefault(require("./rootSaga"));
function configureStore(preloadedState) {
    var sagaMiddleware = (0, redux_saga_1.default)();
    var middlewares = [loggerMiddleware_1.default, sagaMiddleware];
    var middlewareEnhancer = redux_1.applyMiddleware.apply(void 0, middlewares);
    var enhancers = [middlewareEnhancer];
    var composedEnhancers = redux_1.compose.apply(void 0, enhancers);
    var store = (0, redux_1.createStore)(rootReducer_1.default, preloadedState, composedEnhancers);
    sagaMiddleware.run(rootSaga_1.default);
    return store;
}
exports.default = configureStore;
